import { Table as TableAntd } from 'antd';
import { createStyles } from 'antd-style';
import styled from 'styled-components';
import { useWindowSize } from '@/hooks';
import { useTableActions } from './hooks/useTableActions';
import { useTableColumns } from './hooks/useTableColumns';
import { formatTableData, getTableSize } from './utils';

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `
  };
});

export const Table = ({
  data,
  activeTab,
  isDocumentTable,
  isVerification,
  onClick,
  adminView,
  referralView = false,
  referralToken,
  onDelete,
  isOpenButtonDisabled,
  isOpenButtonEnabled,
  isDocumentsFromQuestionnaires = false
}) => {
  const { styles } = useStyle();
  const { width: windowWidth } = useWindowSize();
  const { downloadPdf } = useTableActions({ referralView, referralToken });

  const columns = useTableColumns({
    windowWidth,
    isVerification,
    adminView,
    isDocumentTable,
    isOpenButtonDisabled,
    isOpenButtonEnabled,
    referralView,
    onClick,
    onDelete,
    downloadPdf,
    isDocumentsFromQuestionnaires,
    activeTab
  });

  const dataModified = formatTableData(data, isVerification, isDocumentTable);

  return (
    <StyledContainer>
      <StyledCard>
        <TableAntd
          className={styles.customTable}
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={dataModified}
          pagination={false}
          size={getTableSize(windowWidth)}
        />
      </StyledCard>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
`;

const StyledCard = styled.div`
  flex-grow: 1;
  width: 100%;
`;
